var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9819",
    "data-name": "Group 9819",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 100,
    viewBox: "0 0 116 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5295",
    "data-name": "Rectangle 5295",
    width: 116,
    height: 100,
    fill: "#a1a1b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9796",
    "data-name": "Group 9796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27708",
    "data-name": "Path 27708",
    d: "M0,14.285A14.407,14.407,0,0,1,14.5,0h87A14.408,14.408,0,0,1,116,14.285V85.714A14.408,14.408,0,0,1,101.5,100h-87A14.408,14.408,0,0,1,0,85.714ZM73.361,38.058a5.464,5.464,0,0,0-8.972,0L44.678,66.54l-6-7.389a5.474,5.474,0,0,0-8.474,0L15.7,77.009a5.28,5.28,0,0,0-.658,5.669,5.447,5.447,0,0,0,4.894,3.036H96.062a5.415,5.415,0,0,0,4.8-2.857,5.31,5.31,0,0,0-.317-5.514ZM25.375,35.714A10.716,10.716,0,1,0,14.5,25,10.8,10.8,0,0,0,25.375,35.714",
    fill: "#a1a1b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/PlaceholderImage.e9fc6abd8124470891f92437fca49a64.svg";
export { ForwardRef as ReactComponent };